// Import Types
import type { PredefinedCategories, PredefinedListRowData, PredefinedRegions } from 'types';
// Import Configs
import { CRMRequestService, getCancelableRequest } from './http.config';

const PredefinedHttpService = {
    getPredefinedList: () => {
        return getCancelableRequest<PredefinedListRowData[]>({
            requestService: CRMRequestService,
            endpointPath: () => '/Predefined/List',
        });
    },
    getCategories: () => {
        return getCancelableRequest<PredefinedCategories[]>({
            requestService: CRMRequestService,
            endpointPath: () => '/Predefined/GetCategories',
        });
    },
    getRegions: () => {
        return getCancelableRequest<PredefinedRegions[]>({
            requestService: CRMRequestService,
            endpointPath: () => '/Predefined/GetRegions',
        });
    },
};

export default PredefinedHttpService;
